import React, { useState, useEffect, useRef } from 'react';
import { ArrowLeft, Eye, ArrowRight, Plane, Heart, MapPin, Calendar, Camera, Star, Globe, Play, Pause } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const VideoAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const videoRef = useRef(null);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleExpand = () => {
    if (onExpand && !isInPreview) {
      onExpand();
    }
  };

  return (
    <div className={`w-full h-full relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50 bg-black' : ''}`}>
      {!isExpanded ? (
        <div className="relative h-full">
          <div 
            className={`relative cursor-pointer transform transition-all duration-300 ${
              !isInPreview ? 'hover:scale-105' : ''
            } w-full h-full`}
            onClick={handleExpand}
            onMouseEnter={() => setShowControls(true)}
            onMouseLeave={() => setShowControls(false)}
          >
            <div className="relative w-full h-full overflow-hidden">
              <video
                ref={videoRef}
                className="w-full h-full object-cover"
                muted
                loop
                playsInline
                autoPlay
              >
                <source src="/assets/Lenovo.MP4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>

              <div className="absolute top-2 left-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium">
                AD
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full h-full flex items-center justify-center relative">
          <div className="relative w-full h-full max-w-4xl">
            <video
              ref={videoRef}
              className="w-full h-full object-contain"
              controls
              autoPlay
              muted
              loop
              playsInline
            >
              <source src="/assets/Lenovo.MP4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </div>
  );
};

function LenovoAd() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
       <Helmet>
       <title>
        Lenovo Brand | CTV Carousel Band Ad Showcase by Bidbox
        </title>
        <meta
          name="description"
          content="Discover how Lenovo campaigns run in CTV Carousel Band ads. Explore impactful creatives & engaging strategies that boost brand visibility."
        />
        {/* <meta
          name="keywords"
          content="Discover how Recard campaigns run in CTV Quiz ads. Explore Bidbox’s creative retargeting strategies that boost engagement & conversions."
        /> */}
         <link
          rel="canonical"
          href="https://bidbox.ai/ctv-carousel-l-band/lenovo"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
    </Helmet>
      <div className="min-h-screen bg-gray-50 mt-10">
        <div className="container mx-auto px-4 py-8 lg:py-12">
          <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
            {/* Left column - Content */}
            <div className="flex-1 lg:max-w-lg">
              {/* Header */}
              <header className="animate-slide-up">
                <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                  <div className="flex flex-wrap items-center gap-3 mb-3">
                    <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                    Watch It. Browse It. Buy Into It.
                    </h1>
                    <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                    CTV Carousel L Band
                    </span>
                  </div>
                </div>
              </header>

              {/* Content Section */}
              <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
                <div className="mb-8">
                  <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                  ELEVATE YOUR CTV EXPERIENCE
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                  This CTV carousel ad blends video storytelling with remote integrated carousel. While the ad plays on screen, users can use their remote to scroll through a carousel, each with detailed specs and rich visuals. It’s immersive and engaging. Just integrate your video and product info to launch a seamless, high-impact CTV experience.                  </p>
                    <Link to='/contact'>
                  <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                    <span>Start with this Template</span>
                    <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                  </button>
                  </Link>
                </div>
              </div>
            </div>

            {/* Right column - TV Mockup */}
            {/* <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-16">
              <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
               
                <div className="w-full max-w-xl mx-auto">
              
                  <div className="relative bg-gray-900 rounded-xl p-4 sm:p-6 md:p-2 shadow-xl">
                 
                    <div className="bg-black rounded-xl overflow-hidden relative" style={{ aspectRatio: '16/9' }}>
                    =
                      <div className="w-full h-full bg-gray-100 relative">
                        
                        <div className="absolute inset-4 rounded-lg overflow-hidden">
                          <VideoAdContent 
                            isInPreview={true}
                            isExpanded={isExpanded}
                            onExpand={() => setIsExpanded(true)}
                            onClose={() => setIsExpanded(false)}
                          />
                        </div>
                      
                        <div className="absolute bottom-2 right-2 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs">
                          HD
                        </div>
                      </div>
                    </div>
                    
                   
                  </div>
              
                  <div className="flex justify-center mt-1">
                    <div className="w-32 sm:w-40 md:w-48 h-3 sm:h-4 bg-gray-700 rounded-full shadow-md"></div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* Right column - TV Mockup */}
        <div className="flex-1 w-full max-w-screen-sm mx-auto px-4 sm:px-6 mt-8 lg:mt-20 ">
          <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
            {/* TV Mockup */}
            <div className="w-full ">
              {/* TV Frame */}
              <div className="relative bg-gray-900 rounded-lg p-2 sm:p-2 md:p-2 shadow-md">
                {/* Screen */}
                <div className="bg-black rounded-xl overflow-hidden relative" style={{ aspectRatio: '16/9' }}>
                  {/* TV Screen Content */}
                  <div className="w-full h-full bg-gray-100 relative">
                    {/* Video Ad positioned in center */}
                    <div className="absolute inset-0 rounded-lg overflow-hidden">
                      <VideoAdContent 
                        isInPreview={true}
                        isExpanded={isExpanded}
                        onExpand={() => setIsExpanded(true)}
                        onClose={() => setIsExpanded(false)}
                      />
                    </div>
                    
                    {/* TV UI Elements */}
                    {/* <div className="absolute bottom-2 right-2 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs">
                      HD
                    </div> */}
                  </div>
                </div>
                
                {/* TV Brand/Model indicator */}
                <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2">
                  <div className="w-8 h-1 bg-gray-600 rounded-full"></div>
                </div>
              </div>
              
              {/* TV Stand - Similar to reference image */}
              <div className="flex justify-center items-end mt-10 relative">
                {/* Center base/platform */}
                {/* <div className="w-32 sm:w-40 md:w-48 h-2 bg-gray-700 rounded-full shadow-md relative z-10 mt-6"></div> */}
                
                {/* Stand legs/supports - positioned like in reference image */}
                <div className="absolute bottom-0 flex justify-between w-40 sm:w-48 md:w-56">
                  {/* Left leg */}
                  <div className="w-3 sm:w-4 h-8 sm:h-10 bg-gray-800 rounded-b-lg shadow-lg transform -skew-x-12"></div>
                  {/* Right leg */}
                  <div className="w-3 sm:w-4 h-8 sm:h-10 bg-gray-800 rounded-b-lg shadow-lg transform skew-x-12"></div>
                </div>
              </div>
              
              {/* Optional: Stand reflection/shadow */}
              <div className="flex justify-center mt-1">
                <div className="w-48 sm:w-56 md:w-64 h-1 bg-gray-300 opacity-30 rounded-full blur-sm"></div>
              </div>
            </div>
     
       
          </div>
        </div>
        </div>
        </div>

        {/* Expanded Video Overlay */}
        {isExpanded && (
          <div className="fixed inset-0 z-50">
            <VideoAdContent 
              isExpanded={true}
              onClose={() => setIsExpanded(false)}
            />
          </div>
        )}

        <style jsx>{`
          @keyframes slide-up {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes fade-in {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          
          .animate-slide-up {
            animation: slide-up 0.6s ease-out forwards;
          }
          
          .animate-fade-in {
            animation: fade-in 0.6s ease-out forwards;
          }
        `}</style>
      </div>

    <div className="max-w-7xl mx-auto px-4 py-10">
              <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
        
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {/* Card 1 */}
                <Link to="/ctv-qr-code-l-band/dlf" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                  <img
                    src="/assets/dlf.webp"
                    alt="Card 1"
                    className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                    <h2 className="text-lg font-semibold">DLF</h2>
                  </div>
                </Link>
        
                {/* Card 2 */}
                <Link to="/dynamic-calculator/zakat" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                  <img
                    src="/assets/zakat.webp"
                    alt="Card 2"
                    className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                    <h2 className="text-lg font-semibold">Zakat Calculator</h2>
                  </div>
                </Link>
        
                {/* Card 3 */}
                <Link to="/interactive-selector/donation" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                  <img
                    src="/assets/donation.png "
                    alt="Card 3"
                    className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                    <h2 className="text-lg font-semibold">Donation</h2>
                  </div>
                </Link>
        
                {/* Card 4 */}
                <Link to="/spin-the-wheel/mamaearth" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                  <img
                    src="/assets/mam1.jpg"
                    alt="Card 4"
                    className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                    <h2 className="text-lg font-semibold">Mama Earth</h2>
                  </div>
                </Link>
        
               
              </div>
            </div>
    </>
  );
}

export default LenovoAd;